import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ExamService } from '@app-services/test/exam.service';
import { LocalStorageService } from 'ngx-webstorage';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app-environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'app-submit-confirmation',
  templateUrl: './submit-confirmation.component.html',
  styleUrls: ['./submit-confirmation.component.css']
})
export class SubmitConfirmationComponent implements OnInit {
  countdown: any;
  markedforreviewcount: any = 0;
  unasweredquestionscount: any = 0;

  answeredCount: any = 0;
  notAnsweredCount: any = 0;
  visitedCount: any = 0;
  notVisitedCount: any = 0;
  notAnsweredMarkReviewCount: any = 0;
  visitedMarkReviewCount: any = 0;
  answeredMarkReviewCount: any = 0;
  totalNumberOfQuestionForTest = 0;
  leftOverTime: any = '';
  examInfo: any;
  metaName: any;
  scoreToiStatusURL = environment?.scoreToiStatusURL;
  scoreToiKey = environment?.scoreToiKey;
  questionType: any;
  constructor(private dialogRef: MatDialogRef<SubmitConfirmationComponent>, private storage: LocalStorageService, private examService: ExamService, private gaService: GAnalyticsService, private http: HttpClient) { }

  ngOnInit(): void {

    this.countdown = this.storage.retrieve('examcountdown');
    this.examInfo = this.examService?.getPresentExamInfo();
    this.metaName = this.examInfo?.isLCAssignment ? "assignment": "test";
    //let subjectwiseresponses = this.storage.retrieve("quesResponses") || [];
    let subjectwiseresponses =   this.examService.get_max_limit_webstorage("quesResponses")|| [];

    
    subjectwiseresponses && subjectwiseresponses.forEach((subs: any) => {
      const subReport: any = {};
      subReport.examService = this.examService;
      doLegendWiseQuestionCountCalculation(subs.responses || [], 0, (subs.responses || []).length, subReport);
      this.answeredCount += subReport.answeredCount;
      this.notAnsweredCount += subReport.notAnsweredCount;
      this.visitedCount += subReport.visitedCount;
      this.notVisitedCount += subReport.notVisitedCount;
      this.notAnsweredMarkReviewCount += subReport.notAnsweredMarkReviewCount;
      this.visitedMarkReviewCount += subReport.visitedMarkReviewCount;
      this.answeredMarkReviewCount += subReport.answeredMarkReviewCount;
      localStorage.setItem('totalUnAttemptedQuestion', JSON.stringify(this.notVisitedCount));

    })
    let examType = this.examService?.rules?.examtype ? this.examService?.rules?.examtype :  '';
    if(examType == "subjectivemocktest") {
      this.questionType = "Subjective";
    }
    let source = this.examService?.rules?.source ? this.examService?.rules?.source :  '';
    let eventExamname = examType ? (examType == 'PREVIOUSYEAR' ? 'PYP Test Submitted' : examType == 'MOCKTEST' ? 'MCT Submitted' : examType == 'TIMEBOUND' ? examType == 'TIMEBOUND' : '') : '';
    if (eventExamname && examType) {
      this.gaService.webEngageEvent({
        'event': eventExamname,
        'Not answered': this.notAnsweredCount,
        'Answered': this.answeredCount,
        'Not Visited': this.notVisitedCount,
        'Not Answered and Marked for Review': this.notAnsweredMarkReviewCount,
        'Answered and Marked for Review': this.answeredMarkReviewCount,
      })
    } else if (examType == 'SCHOLARSHIPTEST') {
      this.gaService.webEngageEvent({
        'event': 'score exam submitted',
        'Date and Time': new Date(),
        'Exam name': this.examService?.examInfo?.schedulename
      })
    } else if (examType == 'SCOREMOCKTEST') {
      this.gaService.webEngageEvent({
        'event': 'Score_Mock_Test_Submitted',
        'Not_answered': this.notAnsweredCount,
        'Answered': this.answeredCount,
        'Not_Visited': this.notVisitedCount,
        'Not_Answered-Marked_Review': this.notAnsweredMarkReviewCount,
        'Answered_Marked_Review': this.answeredMarkReviewCount,
      })
    }
    else if (examType == 'SCOREAWAT' && source == 'score-toi') {
      let userDetais = localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')):{}
      this.http.put<any>(`${this.scoreToiStatusURL}?apiKey=${this.scoreToiKey}`,{
        "regId": userDetais?.userId,
        "scoreStatus": "Completed",
      }).subscribe(res=>{
        console.log(res);
      })
    }

    let counter = this.storage.retrieve('examcountdown');
    var time_in_seconds = parseFloat(counter) * 60;
    this.countdown = new Date(time_in_seconds * 1000)?.toISOString()?.substr(11, 8)
    //this.countdown = parseInt('' + 1*this.countdown/ 60) + ':' + (1*this.countdown % 60);
    let newcounter = +counter &&  Number.parseFloat(counter).toFixed(2) ?  Number.parseFloat(counter).toFixed(2) :  +counter;
    if (+counter > 60) {
      this.leftOverTime  =  this.convertMinsToHrsMins (newcounter) 
    } else {
      this.leftOverTime = newcounter+ ' minutes'
      const duration = moment.duration(newcounter, 'minutes');
      this.leftOverTime =`${duration.minutes()}min:${duration.seconds()}sec`
    }
    this.totalNumberOfQuestionForTest = JSON.parse(localStorage.getItem('totalNumberOfQuestionForTest'));
  }
  convertMinsToHrsMins (minutes) {
    var h :any= Math.floor(minutes / 60);
    var m :any = minutes % 60;
    h = h < 10 ? '0' + h : h; 
    m = m < 10 ? '0' + m : m; 
    var minutes_format =  Number.parseFloat(m).toFixed(0) || 0
    return h + 'hrs ' + minutes_format +'min ';
  }

  backToTest() {
    this.dialogRef.close(null);
  }

  finishTest() {
    this.dialogRef.close('finish');
  }

}

export function doLegendWiseQuestionCountCalculation(responses: any, startIndex: any, count: any, report: any) {

  report.answeredCount = 0;
  report.notAnsweredCount = 0;
  report.visitedCount = 0;
  report.notVisitedCount = 0;
  report.notAnsweredMarkReviewCount = 0;
  report.visitedMarkReviewCount = 0;
  report.answeredMarkReviewCount = 0;
  //responses = this.displayedResponses || [];
  responses = responses || [];
  let examInfo = report.examService?.getPresentExamInfo();
  console.log('examInfo: ', examInfo);
if(examInfo?.examtype !="subjectivemocktest"){
  for (let i = startIndex, res, len = startIndex + count; i < len; i++) {
    res = responses[i];
    if (res.isvisited) {// && !response.ismarkedforreview) {
      if (!res.answer_given) {
        if (res.ismarkedforreview) {
          report.notAnsweredMarkReviewCount++;
        } else {
          report.notAnsweredCount++;
        }
      } else {
        if (res.ismarkedforreview) report.answeredMarkReviewCount++;
        else report.answeredCount++;
      }
    } else {
      report.notVisitedCount++
    }
  }
}else{
  for (let i = startIndex, res, len = startIndex + count; i < len; i++) {
    res = responses[i];
    if (res.isvisited) {// && !response.ismarkedforreview) {
      if (res.ismarkedforreview) {
        report.visitedMarkReviewCount++;
      } else {
        report.visitedCount++;
      }
    } else {
      report.notVisitedCount++
    }

  } 
  }
}